// RiderOutlets Main JS
// v1.0 | 2026-04-26

// ─── Image Gallery Switcher ───
function switchImg(thumb, src) {
  // Update main image
  const mainImg = document.getElementById('main-img');
  if (mainImg) {
    mainImg.style.opacity = '0';
    setTimeout(() => {
      mainImg.src = src;
      mainImg.style.opacity = '1';
    }, 150);
  }
  // Update active thumb
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// Add CSS transition for image fade
document.addEventListener('DOMContentLoaded', () => {
  const mainImg = document.getElementById('main-img');
  if (mainImg) {
    mainImg.style.transition = 'opacity 0.15s ease';
  }

  // ─── Nav scroll effect ───
  const nav = document.querySelector('.nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        nav.style.boxShadow = '0 1px 12px rgba(0,0,0,0.08)';
      } else {
        nav.style.boxShadow = 'none';
      }
    });
  }

  // ─── Scroll reveal animation ───
  const revealEls = document.querySelectorAll('.product-card, .category-card, .specs-table tr');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    revealEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = `opacity 0.4s ease ${i * 0.05}s, transform 0.4s ease ${i * 0.05}s`;
      observer.observe(el);
    });
  }
});
